import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-271a8612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#banner",
    class: "router-link"
  }, "HOME")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#feature",
    class: "router-link"
  }, "FEATURES")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#products",
    class: "router-link"
  }, "PRODUCTS")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#footer",
    class: "router-link"
  }, "CONTACT US")
], -1))
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { id: "menu-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_box_icon = _resolveComponent("box-icon")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "side-nav",
      class: _normalizeClass(_ctx.hide)
    }, [
      _createElementVNode("nav", null, [
        (_ctx.$route.name=='home')
          ? (_openBlock(), _createElementBlock("ul", _hoisted_1, _hoisted_6))
          : (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "router-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("HOME")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/product-1",
                  class: "router-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("งานปรับภูมิทัศน์ ..")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/product-2",
                  class: "router-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("งานถนน, ลานจอดรถ ..")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/product-3",
                  class: "router-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("งานกันซึม")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/product-4",
                  class: "router-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("งานกำแพงกันดิน ..")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/product-5",
                  class: "router-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Drainage Cell")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: "/product-6",
                  class: "router-link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("พลาสติกรองเท ..")
                  ]),
                  _: 1
                })
              ])
            ]))
      ])
    ], 2),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_box_icon, {
        name: _ctx.iconName,
        size: "30px",
        weight: "500",
        color: "#fff",
        onClick: _ctx.openSideNav
      }, null, 8, ["name", "onClick"])
    ]),
    _createVNode(_component_RouterView)
  ], 64))
}